import { toastError, toastSuccess } from './toasts';

const copyLinkToClipboard = (link: string) => {
  navigator.clipboard
    .writeText(link)
    .then(() => {
      toastSuccess('Texto copiado al portapapeles');
    })
    .catch((err) => {
      console.error('Error al copiar al portapapeles: ', err);
      toastError('No se pudo copiar. Probá de nuevo o copialo a mano.');
    });
};

export default copyLinkToClipboard;
